export const getVisitsOnLocalStorage = visits => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.includes('visit')) visits.push(localStorage.getItem(key));
  }
};
